export default __webpack_public_path__ + "static/media/coffeescript.8f556143.svg";